// 
// 
//*************************************************************//
//                                                             //
//    ╔═╗╔═╗╔╦╗╔═╗╔═╗╔╗╔╔═╗╔╗╔╔╦╗╔═╗  ╔═╗╦ ╦╔╦╗╦╔╦╗╔═╗╦═╗╦╔═╗  //
//    ║  ║ ║║║║╠═╝║ ║║║║║╣ ║║║ ║ ║╣   ╠═╣║ ║ ║║║ ║ ║ ║╠╦╝║╠═╣  //
//    ╚═╝╚═╝╩ ╩╩  ╚═╝╝╚╝╚═╝╝╚╝ ╩ ╚═╝  ╩ ╩╚═╝═╩╝╩ ╩ ╚═╝╩╚═╩╩ ╩  //
//                                                             //
//*************************************************************//

import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
// ITEM QUE SE DEBE MODIFICAR PARA LOS CRUD
import {Auditoria} from './../recursos/modelo/auditoria';
import {AuditoriaService} from './../recursos/servicios/auditoria.service';


declare const $: any;

declare var swal: any;

@Component({
    moduleId: module.id,
    selector: 'cmp-list-auditoria',
    templateUrl: './view/list-auditoria.component.html',
    styleUrls: ['./css/list-auditoria.component.scss'],
    providers: [AuditoriaService]
})
export class ListAuditoriaComponent implements OnInit {
//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─

    // ITEM DEL CRUD
    origenCRUD = "Auditoria";
    // variables de pantalla

    // permite cambiar a la lista o al formulario
    // (listaBusqueda , formuulario)
    vista = "listaBusqueda";
    selectedLista = true;
    search = "";
    noHayResultados = false;

    //variables modelo
    ItemLista: Auditoria[];
    ItemSelected = new Auditoria(0, "", "", "", "");

    constructor(private auditoriaService: AuditoriaService,
                private route: ActivatedRoute) {

        this.ItemLista = [];

        this.route.params.subscribe(params => {
            if (params['busqueda']) {
                this.search = params['busqueda'];
                this.getBusqueda(this.search);
            }
        });

    }

    ngOnInit() {
    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴       

    help() {
        $.getScript("./assets/js/core/material-google.js", function () {
            setTimeout(function () {
                eval("$('#helpAdd').tapTarget('open');")
            }, 700);
            setTimeout(function () {
                eval("$('#helpAdd').tapTarget('close');")
            }, 5000);

            setTimeout(function () {
                eval("$('#helpLista').tapTarget('open');")
            }, 5100);
            setTimeout(function () {
                eval("$('#helpLista').tapTarget('close');")
            }, 9000);

            setTimeout(function () {
                eval("$('#helpGrid').tapTarget('open');")
            }, 9100);
            setTimeout(function () {
                eval("$('#helpGrid').tapTarget('close');")
            }, 13000);

            setTimeout(function () {
                eval("$('#helpBusqueda').tapTarget('open');")
            }, 13100);
            setTimeout(function () {
                eval("$('#helpBusqueda').tapTarget('close');")
            }, 17000);
        });
    }

    realizarBusqueda() {
        this.getBusqueda(this.search);
    }

    eliminar(item) {
        swal({
            title: '¿Está seguro que desea eliminar al usuario? ',
            text: "El usuario: " + item.nombre + ", " + item.apellido,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminarlo!'
        }).then(function () {
            swal(
                'Usuario eliminado!',
                'La eliminación es lógica, por ende, el usuario sigue existiendo pero inhabilitado',
                'success'
            );
            item.estado = "INACTIVO";
        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
            }
        })
    }

    activar(item) {
        swal({
            title: '¿Está seguro que desea activar al usuario? ',
            text: "El usuario: " + item.nombre + ", " + item.apellido,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, activarlo!'
        }).then(function () {
            swal(
                'Usuario activado!',
                '',
                'success'
            );
            item.estado = "ACTIVO";
        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
            }
        })
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐ 
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐ 
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘ 

    private getBusqueda(term) {
        this.ItemLista = this.auditoriaService.getAuditoria();
    }
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/auditoria/cmp-list-auditoria/list-auditoria.component.ts